// @flow
import type { AppState } from 'reducers/app';
import type { StoreState } from 'reducers';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Label } from 'semantic-grab-ui/src';

import api from 'utils/api-utils';
import { LazyLoad } from 'components/custom/LazyLoad';

type Props = {
  appState: AppState,
  geofence: Object,
  show: boolean,
  canEdit: boolean,
  onChange: Function,
};

export class GeofenceDisplayModal extends Component {
  props: Props;
  constructor(props: Props) {
    super(props);

    this.state = {
      geofence: props.geofence,
      modalOpen: this.props.show,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    this.setState({ modalOpen: nextProps.show });
  }

  componentDidMount = () => {
    if (!this.props.geofence.code) return;

    api.get(this.props.appState, `/geofences/${this.props.geofence.code}`)
      .then((response: Object) => {
        // the geometry is guaranteed to be multipolygon for all the geofences
        const coordinates = response.data.geometry.coordinates;
        this.setState({ coordinates, geofence: response.data });
      });
  }

  handleClose = () => {
    this.setState({ modalOpen: false });
    this.props.onChange(false);
  }

  handleEdit = () => {
    this.setState({ modalOpen: false });
    this.props.onChange(true);
  }

  render() {
    return (
      <Modal open={this.state.modalOpen} onClose={this.handleClose}>
        <Modal.Header>{this.props.geofence.name}</Modal.Header>
        <Modal.Content>
          <div className="geo-rule-map">
            <LazyLoad
              asyncImport={() => import('./GrabMap.tsx')}
              childProps={{ coordinates: this.state.coordinates }}
            />
          </div>
          {this.props.geofence.version === this.state.geofence.version ?
            <Label>
              This is the latest geofence version
            </Label>
            :
            <div>
              <Label>
                This is not the latest geofence version
              </Label>
              <div>
                <Label>
                  This version:
                  <Label.Detail>{this.props.geofence.version}</Label.Detail>
                </Label>
              </div>
              <div>
                <Label>
                  Latest version:
                  <Label.Detail>{this.state.geofence.version}</Label.Detail>
                </Label>
              </div>
            </div>
          }
        </Modal.Content>
        <Modal.Actions>
          <Button basic onClick={this.handleClose}>Close</Button>
          <Button
            disabled={!this.props.canEdit}
            basic
            onClick={this.handleEdit}
          >
            Edit
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export function mapStateToProps(state: StoreState, ownProps: Object) {
  return {
    ...ownProps,
    appState: state.app,
  };
}

export default connect(mapStateToProps)(GeofenceDisplayModal);
